export const Alert = ({ errorMessage, successMessage }) => {
  return (
    <>
      {(errorMessage || successMessage) && (
        <div className={`alert ${errorMessage ? 'alert-danger' : 'alert-success'}`} role='alert'>
          {errorMessage || successMessage}
        </div>
      )}
    </>
  );
};
